
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleet as ObiLightningSleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet.js';
 
 
 

 
 export const ObiLightningSleet = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet',
   elementClass: ObiLightningSleetElement,
   events: {
     
   }
  });
 
 